export enum colors {
    black= '#000', // noir
    loyautePrimary= '#250934', //noir-teinte
    grey = '#F1EFF1', //gris
    grey50 = '#F2F2F2', //gris des labels inputs
    grey100= '#CEC6D2', //gris-100
    grey200= '#BBB0BF', //gris-200
    grey300= '#9D8FA3', //gris-300
    grey400= '#77687E', //gris-400
    grey500= '#26262614',
    newGrey= '#0000004A',
    white= '#FFFFFF', //blanc
    seance= '#801AB8', //mauve
    redBrand= '#FF3000', //rouge-brand
    redUi= '#D81E05', //rouge-ui
    metroPrimary= '#D81E05',
    metroSecondary= '#6E1919',
    jeanCoutuprimary= '#0099D7',
    jeanCoutuSecondary= '#C43B40',
    superCPrimary= '#FEDB00',
    superCSecondary= '#EE3124',
    brunetPrimary= '#87BAD9',
    brunetSecondary= '#008ED0',
    premiereMoissonPrimary= '#000000',
    premiereMoissonSecondary= '#D8B033',
    focusLight= '#F5EDFA',
    focusDark= '#661593',
    error= '#D81E05',
    disabled= '#BBB0BF'
}